import isMobile from 'ismobilejs'


export default (theme) => ({
    modal: {
        "& .MuiPaper-root" :{
          maxHeight:'90%',
          width:'90%'
        }
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '65px'
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    textoLogin:{
        fontSize: '20px',
        fontWeight: '700',
        margin: '18px 0 18px 0'
    },
    textoForm:{
        marginBottom: '10px'
    },
    boldText:{
        fontWeight: '700'
    },
    gridVerification:{
        margin: '35px 0 35px 0'
    },
    firstText:{
        marginTop: '15px',
        fontSize: '15px'
    },
    aaLoaderModal: {
        height: isMobile.any ? '100vh' : '70vh' ,
        width: isMobile.any ? '100%' : '350px',
        display: 'grid',
        justifyContent: 'center',
        alignContent: 'center'
    },
    aaLoader:{
        height: '100vh',
        display: 'grid',
        justifyContent: 'center',
        alignContent: 'center'
    },
});